import React from 'react';

import {
    className,
    Heading,
    Text,
    ImageComponent,
} from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';
import { useTranslate } from 'soluble-gatsby-source';
import style from './style.module.scss';

export default function CardWebinarComponent({
    image,
    title,
    text,
    category,
    url,
    buttonDetached,
    colorScheme,
}) {
    const translation = useTranslate();

    return (
        <div
            {...className(
                `${style.wrapper} d-lg-flex flex-lg-column justify-content-lg-between`
            )}
        >
            <div>
                <ImageComponent image={image} />
                <div {...className(`pt-4`)}>
                    <Text tag="span" mb={{ xs: 2 }} className={`${style.tag}`}>
                        {category && category.title ? category.title : '&nbsp;'}
                    </Text>
                    <Heading tag="h4" className={`${style.heading}`}>
                        {title}
                    </Heading>
                    <Text tag="div" className="body" mb={{ xs: 3 }}>
                        {text}
                    </Text>
                </div>
            </div>
            <div {...className(`pb-4`)}>
                <ButtonComponent
                    focusWhite={colorScheme == 'primary' ? true : false}
                    buttonClassName={buttonDetached ? '' : style.button}
                    button={{
                        detached: buttonDetached ? true : false,
                        externalLink: url,
                        label: translation['guides-section.guide.cta'].text,
                        target: '_blank',
                    }}
                />
            </div>
        </div>
    );
}
